import { Settings24Regular, SignOut24Regular } from "@fluentui/react-icons";
import { Button } from "@fluentui/react-components";

import styles from "./ChangePowerplantButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
    title?: string;
}

export const ChangePowerplantButton = ({ className, onClick, title }: Props) => {
    return (
        <div className={`${styles.container} ${className ?? ""}`}>
            <Button icon={<SignOut24Regular />} onClick={onClick}>
                {title}
            </Button>
        </div>
    );
};
